import { render, staticRenderFns } from "./ECInput.vue?vue&type=template&id=04b8e6b2&scoped=true&"
import script from "./ECInput.vue?vue&type=script&lang=js&"
export * from "./ECInput.vue?vue&type=script&lang=js&"
import style0 from "./ECInput.vue?vue&type=style&index=0&id=04b8e6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8e6b2",
  null
  
)

export default component.exports